import { render, staticRenderFns } from "./inputCamera.vue?vue&type=template&id=f245daea"
import script from "./inputCamera.vue?vue&type=script&lang=js"
export * from "./inputCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports